import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'inc-table-row-inner',
  templateUrl: './table-row-inner.component.html',
  styleUrls: ['./table-row-inner.component.scss'],
})
export class TableRowInnerComponent implements OnInit {

  @Input() element: any;

  constructor() { }

  ngOnInit() { }

}
